"use strict";
import React from 'react'
import { Popup } from 'semantic-ui-react'
import TimeAgo from 'react-timeago'
import moment from 'moment';
import momentDateAndTime from './momentDateAndTime';

function formatter(date, now) {
    if (now === 'second') {
        return `${date} sec ago`;
    } else if (now === 'minute') {
        return `${date} min ago`;
    } else if (now === 'hour') {
        return `${date} hr ago`;
    } else if (now === 'day') {
        return `${date} day ago`;
    } else if (now === 'week') {
        return `${date} week ago`;
    } else if (now === 'month') {
        return `${date} mon ago`;
    } else if (now === 'year') {
        return `${date} yr ago`;
    } else {
        return `${date}`;
    }
}

function reactTimeAgo(date, position) {
    let today = moment(new Date());
    let datePassed = date;
    return date ?
        today.diff(datePassed, 'days') <= 1 ?
            <Popup
                className="popupStyled"
                position={position ? position : "left center"}
                inverted
                trigger={
                    <TimeAgo title='' live={false} date={date} formatter={formatter} />
                }
                content={momentDateAndTime(date)}
            />
            : moment(date).format('MMM DD, YYYY')
        : moment().format('MMM DD, YYYY')

};

export default reactTimeAgo;